import { AlertTriangle } from "lucide-react";
import { IntentButton } from "./intent-button";

export interface ErrorStateProps {
  message?: string;
  correlationId?: string;
  onRetry?: () => void;
}

export function ErrorState({
  message = "Something went wrong while loading this view.",
  correlationId,
  onRetry,
}: ErrorStateProps) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-3 p-12 text-center">
      <AlertTriangle className="size-10 text-destructive" aria-hidden />
      <h3 className="text-lg font-semibold">Unable to load</h3>
      <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      {correlationId ? (
        <p className="text-xs font-mono text-muted-foreground">Reference: {correlationId}</p>
      ) : null}
      {onRetry ? <IntentButton onClick={onRetry}>Retry</IntentButton> : null}
    </div>
  );
}
